define('ArtworkUpload.PendingRegistry', [], function () {
    'use strict';

    // Bridges "these are the artworks currently uploaded on the PDP for item
    // X" to "the next addLine() call for item X should carry them as a line
    // option, or be blocked if the item requires artwork and none is set".
    // Keyed by item internalid because the PDP only ever has one item in
    // scope at a time.
    var pending = {}; // itemInternalId -> array of artwork objects
    var activeWidgets = {}; // itemInternalId -> the mounted ArtworkUpload.PDP.View instance

    return {
        setAll: function (itemInternalId, artworks) {
            if (!itemInternalId) return;
            if (artworks && artworks.length) pending[itemInternalId] = artworks;
            else delete pending[itemInternalId];
        },

        getAll: function (itemInternalId) {
            if (!itemInternalId) return [];
            return pending[itemInternalId] || [];
        },

        clear: function (itemInternalId) {
            if (!itemInternalId) return;
            delete pending[itemInternalId];
        },

        setActiveWidget: function (itemInternalId, widget) {
            if (!itemInternalId) return;
            activeWidgets[itemInternalId] = widget;
        },

        getActiveWidget: function (itemInternalId) {
            if (!itemInternalId) return null;
            return activeWidgets[itemInternalId] || null;
        },

        clearActiveWidget: function (itemInternalId) {
            if (!itemInternalId) return;
            delete activeWidgets[itemInternalId];
        }
    };
});
